import {BackendError} from "@common-core/runtime-js/backend";
import {OperationalEntity} from "@common-core/coat-operational-hierarchy-appsync-model";
import {LookupOperationalEntityData} from "./LookupOperationalEntity";

export const assertOperationalEntityPresent = (result: {
  data?: LookupOperationalEntityData | null;
}): OperationalEntity => {
  if (!result.data?.entity) {
    throw new BackendError(`Operational entity not found`, 404);
  }
  return result.data.entity;
};
